// extracted by mini-css-extract-plugin
export default {"cart-footer":"CartFooter_cart-footer__KH3ic","checkout":"CartFooter_checkout__-30PX","fade-in":"CartFooter_fade-in__6XpOl","dropdown":"CartFooter_dropdown__6z9r-"};